function getLocalModules() {
  return [
    
  ];
}

export async function getModules() {
    return getLocalModules();
}
